import { Injectable } from '@angular/core';
import { TranslateService } from '@galaxy/lexicon';
import { ActivityInterface, WorkflowStepInterface } from '@vendasta/automata';
import { Observable } from 'rxjs';
import { ActivityTableEntry, AutomationDisplayService, NodeData } from '../../common/automation-display.service';
import { StringOperations } from './string-operations-panel/string-operations-panel.component';

@Injectable({ providedIn: 'root' })
export class StringOperationsService extends AutomationDisplayService {
  constructor(protected readonly translateService: TranslateService) {
    super();
  }

  /** Gets text for the activity column in the table. */
  getActivityColumn(_namespace: string, activity: ActivityInterface): ActivityTableEntry {
    const activityData = activity?.activityData ? JSON.parse(activity.activityData) : {};
    return this.tableEntry(
      this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.STRING_FORMATTER.ACTIVITY_TITLE'),
      this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.STRING_FORMATTER.ACTIVITY_SUBTITLE', {
        output: activityData?.string_value,
      }),
    );
  }

  /** The text in an automation node (i.e. the nodes in the graph). */
  getAutomationNodeData(
    _namespace: string,
    _step: WorkflowStepInterface,
    _isWaitUntilNode: boolean,
  ): Observable<NodeData> {
    return this.nodeDisplayData(
      this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.STRING_FORMATTER.TEXT_TITLE'),
      this.noValidationErrorsDetected(),
    );
  }

  getActionSubtitle(_namespace: string, step: WorkflowStepInterface, _isWaitUntil?: boolean): Observable<string> {
    const data = step ? JSON.parse(step.data) : {};
    let operator = 'COMMON.UNKNOWN';
    if (data?.operation) {
      const possibleOperator = StringOperations.get(data?.operation) || '';
      if (possibleOperator) {
        operator = possibleOperator;
      }
    }
    return this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.STRING_FORMATTER.STEP_SUBTITLE_ACTION', {
      operator: this.translateService.instant(operator),
    });
  }
}
